import { RecommendationCategory } from '@snapi/types';
import MotherImg from './images/mother.png';
import FoodImg from './images/food.png';
import Image, { StaticImageData } from 'next/image';

const RecommendationCategoryToIcon: {
  [key in RecommendationCategory]: StaticImageData;
} = {
  [RecommendationCategory.mother]: FoodImg,
  [RecommendationCategory.food]: MotherImg,
};

type RecommendationCategoryIconProps = {
  category: RecommendationCategory;
  height: number;
};

export const RecommendationCategoryIcon = ({
  category,
  height,
}: RecommendationCategoryIconProps) => {
  const icon = RecommendationCategoryToIcon[category];

  if (!icon) {
    return null; // Return null or handle the missing icon case appropriately
  }

  const { width, height: iconHeight } = icon;

  return (
    <div style={{ width: (width / iconHeight) * height }}>
      <Image {...icon} alt={`${category}`} layout="responsive" />
    </div>
  );
};
